<section class="experience">
    <div class="section-name">
        <h6>
            EXPERIENCE
        </h6>
        <div class="line"></div>
    </div>
<div class="experience-wrapper">
    <div class="wrapper-inner">
        <div class="content-wrapper row justify-content-center">
            <div class="col-12 col-md-12 col-lg-4 justify-content-start experience-item since">
                <div class="drop">
                    <img class="round-img" src="../../../assets/about/United_States_Department_of_Defense_Seal.svg.png" alt="OUR HISTORY">
                </div>
                <div class="round"></div>
                <div class="info-content">
                    <h3>OUR HISTORY</h3>
                    <h4>SINCE 1982</h4>

                    <div class="text-content">
                        <p>
                            Key personnel held positions within the Department of Defense, Department of State, The White House, and Maryland State Government.
                        </p>
                        <p>
                            Conceived, Spear-headed, and/or participated directly in; information gathering & analysis, business mgmt., sourcing & procurement, and financial management including the development of The Military Procurement System, FEDLOG sourcing system, and Standard Procurement System.
                        </p>
                    </div>
                </div>

            </div>
            <div class="col-12 col-md-12 col-lg-4 justify-content-start experience-item founded">
                <div class="drop">
                    <img class="round-img" src="../../../assets/about/WorldERP_Globe_Trans.png" alt="Founded in 2005">
                </div>
                <div class="round"></div>
                <div class="info-content">
                    <h3>2005</h3>

                    <h4>FOUNDED</h4>

                    <div class="text-content">
                        <p>
                            Founded in 2005 as a software solutions provider and business consulting firm.
                        </p>
                        <p>
                            Headquartered in Wyoming and now with offices in Maryland, Illinois, Canada, United Kingdom, Malaysia, and Ukraine.
                        </p>
                        <p>
                            WorldERP™ is 100% founder-owned and highly profitable.
                        </p>
                    </div>
                </div>

            </div>
            <div class="col-12 col-md-12 col-lg-4 justify-content-start experience-item core-competencies">
                <div class="drop">
                    <img class="round-img" src="../../../assets/about/WorldERP_Trans_95.png" alt="CORE COMPETENCIES">
                </div>
                <div class="round"></div>
                <div class="info-content">
                    <h3>2020</h3>
                    <h4>CORE COMPETENCIES</h4>
                    <h5 class="title-bordered">WorldERP™ is a multi - disciplinary creative studio.</h5>
                    <div class="text-content">
                        <p>Business Mgmt.: 35+yrs.</p>
                        <p>Efficiency expertise: 20yrs.</p>
                        <p>Sourcing & Procurement: 35+yrs</p>
                        <p>Contract Negotiations & Mgmt.: 20yrs.</p>
                        <p>Project Management: 20yrs.</p>
                        <p>Financial Acct. & Management: 20yrs.</p>
                        <p>Research & Development: 25yrs.</p>
                        <p>Software & Database Design/Dev.: 25yrs.</p>
                        <p>Cybersecurity: 30yrs.</p>
                        <p>Network Management: 20yrs.</p>
                        <p>Artificial Intelligence (AI): 20yrs.</p>
                        <p>Machine Learning: 15yrs.</p>
                        <p>Blockchain: 10yrs.</p>
                        <p>Internet of Things (IoT): 10yrs.</p>
                    </div>
                </div>

            </div>
            <div class="bottom-line">

            </div>
        </div>
    </div>
</div>
</section>
